import { rootApi } from "../../api/rootApi";

export const qrScanTimelineApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchQrScanTimeline: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/qrScanTimeline/`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.body,
      }),
    }),

    fetchQrScanTimelineDetail: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/qrScanTimeline/${params.hitId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
  }),
});

export const {
  useFetchQrScanTimelineMutation,
  useFetchQrScanTimelineDetailMutation,
} = qrScanTimelineApi;
